import React from "react";
import { setLocalUkmId } from "../../../utils/handleChangeUkmId";

type UseTransaksiRedirectProps = {
    ukm: unknown;
    ukmId: number | null;
    userId?: number;
};

export default function useTransaksiRedirect({
    ukm,
    ukmId,
    userId,
}: UseTransaksiRedirectProps) {
    const queryUkmId = React.useMemo(() => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get("redirect");
    }, []);

    React.useEffect(() => {
        if (!queryUkmId || !userId) {
            return;
        }

        setLocalUkmId(userId, Number(queryUkmId));
    }, [queryUkmId, userId]);

    React.useEffect(() => {
        if (!queryUkmId || !userId || !ukm) {
            return;
        }

        window.location.replace("/transaksi");
    }, [queryUkmId, ukm, userId]);

    const isWaitingForRedirectSync =
        Boolean(queryUkmId) && Number(queryUkmId) !== ukmId;

    return {
        queryUkmId,
        isWaitingForRedirectSync,
    };
}
